import * as z from "zod";
import {
  CommonMetadataSchema,
  type ManifestValidationResult,
  validateManifest,
} from "./_shared.js";

export const PromptManifestSchema = z.looseObject({
  name: z.string().min(1),
  description: z.string().min(1),
  version: z.string().optional(),
  keywords: z.array(z.string()).optional(),
  license: z.string().optional(),
  metadata: CommonMetadataSchema.optional(),
});

export type PromptManifest = z.infer<typeof PromptManifestSchema>;

export function validatePrompt(data: unknown): ManifestValidationResult<PromptManifest> {
  return validateManifest(PromptManifestSchema, data);
}
